export const DEFAULT_SORT_CONFIG = { key: null, direction: null };
